<!--
     <FilterSearch
       :filters="QFilters"
       @update="handle_update(QFilters)"
     />
-->

<template>
  <v-text-field
    v-if="!is_mobile"
    v-model="search_text"
    id="explorerHeaderSearchableText"
    name="explorerHeaderSearchableText"
    ref="explorerHeaderSearchableText"
    :placeholder="$vuetify.lang.translator('search_text')"
    single-line
    @input="isTyping = true"
    :class="[props.activator_class ? props.activator_class : 'explorer-table-searchable-text', disabled ? 'disabled-grey-color' : '']"
    background-color="#f2f2f2"
    :color="disabled ? undefined : '$acacac'"
    solo
    flat
    clearable
    dense
    filled
    hide-details	
    :disabled="disabled"
  >
    <v-icon
      slot="append"
      class="explorer-table-searchable-icon"
      :disabled="disabled"
    >
      mdi-magnify
    </v-icon>
  </v-text-field>
  <v-menu
    v-else
    ref="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
    dense
    :disabled="disabled"
  >

    <template v-slot:activator="{ on, attrs }">
      <div>
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          small
          :disabled="disabled"
        >
          <v-icon small>mdi-magnify</v-icon>
        </v-btn>
      </div>
    </template>
    <v-card>
      <v-text-field
        v-model="search_text"
        id="explorerHeaderSearchableText"
        name="explorerHeaderSearchableText"
        ref="explorerHeaderSearchableText"
        :placeholder="$vuetify.lang.translator('search_text')"
        single-line
        @input="isTyping = true"
        background-color="#f2f2f2"
        color="$acacac"
        solo
        flat
        clearable
        dense
        filled
        hide-details
        :disabled="disabled"
      >
      </v-text-field>
    </v-card>
  </v-menu>
</template>

<script>
 import debounce from 'lodash/debounce';
 import { QFilters, get_qfilter } from '@/qunit/filters';

 export default {
   name: 'FilterSearch',

   props: {
     filters: {type: QFilters},
     is_mobile: {type: Boolean, default: false},
     props: {default: () => ({})},
     disabled: Boolean,
   },

   data: () => ({
     isTyping: false,
     search_text: '',
     searchClosed: true,
   }),

   computed: {
   },

   mounted() {
    this.pull_filters()
   },

   methods: {
     launch_update() {
      let filters = new QFilters();
      //filters.search = this.search_text
      filters.set_filter(get_qfilter('search',this.search_text))
       this.$emit('update', filters);
     },

     pull_filters() {
       if (this.search_text != this.filters.get_filter_value('search'))
         this.search_text = this.filters.get_filter_value('search');
     },
     get_value() {
      let filters = new QFilters();
      filters.set_filter(get_qfilter('search',this.search_text));
      return filters;
     },
   },

   watch: {
     filters() {
       this.pull_filters();
     },

     // launch when stop typing wait 1s.
     search_text: debounce(function() {
       this.isTyping = false
     }, 1000),

     isTyping(value) {
       if (!value) {
         if (this.search_text && this.search_text.length >= 3)
           this.launch_update();
         if (!this.search_text)
           this.launch_update();
       }
     },
   },
 }
</script>
